import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Breadcrumb from "sushiweb/Breadcrumb";
import Button from "sushiweb/Button";
import {
  FlexContainer,
  FieldsContainer,
  FieldsSection,
} from "../../../constants/assets/containers";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import Back from "sushiweb/Icons/all/Back";
import * as DriverNotificationActions from "../../../store/actions/DriverNotification";
import * as DriverServiceActions from "../../../store/actions/DriverServices";
import * as UserActions from "../../../store/actions/User";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../../components/Common/Permission";
import variables from "../../../constants/assets/variables";
import fieldsState from "./fieldsState.json";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";
import InfiniteScrollDropdown from "../../../components/Common/InfiniteScrollDropdown";
import DateTimePicker from "../../../components/Common/DateTimePicker";
import BulkUploadFile from "../../../components/BulkUploadFile";
import GeographyDetailsModal from "../../../components/DriverNotification/NewCampaign/GeographyDetailsModal";
import NextView from "../../../components/DriverNotification/NewCampaign/NextView";
import { isValNull } from "../../../utils";

const NewCampaign = (props) => {
  const {
    newCampaignOptions,
    getNewCampaignOptions,
    driverSelectionCSVUpload,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION];
  const history = useHistory();
  const [inputFieldState, setInputFieldState] = useState(fieldsState);
  const [nextView, setNextView] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [isPopup, setIsPopup] = useState(false);
  const [formError, setFormError] = useState("");
  const [driverServicesPriorityFlag, setDriverServicesPriorityFlag] =
    useState(true);

  const notificationForType = [
    { label: "Driver", value: "Driver Details" },
    { label: "Onboarding Applicants", value: "Onboarding Applicants" },
  ];
  const scheduleType = [
    { label: "Send now", value: "NOW" },
    { label: "Schedule Later", value: "LATER" },
  ];
  const driverSelectionType = [
    { label: "Geography", value: "GEOGRAPHY" },
    { label: "CSV", value: "CSV" },
  ];

  const instructionsCSVUpload = [
    "Provide delivery driver IDs (e.g. 34897) as per format given in the sample CSV. We do not accept FE ids anymore. Eg: FE17823 is not acceptable, but 78233 is acceptable.",
    "You can use variables in title and message of the notification using {{}} e.g. {{var1}} or {{var2}}. Whatever is the variable name should exactly match the header of the CSV and all the rows must be filled.<br/>For e.g.<br/>Title: Hey, {{var1}} <br/>Message: Dear Runnr, Your Zomato Background Verification has failed due to {{var2}}. Please find this OTP {{var3}} to do the verification again.<br/>----- CSV File -----<br/> delivery_driver_id,var1,var2,var3<br/>234111,Manan,Some reason,1234<br/>231234,Rahul,Other reason,3214",
  ];
  const instructionsCSVUploadOB = [
    "Provide OB ids (e.g. OB34308) as per format given in the sample CSV.",
    "You can use variables in title and message of the notification using {{}} e.g. {{var1}} or {{var2}}. Whatever is the variable name should exactly match the header of the CSV and all the rows must be filled.<br/>For e.g.<br/>Title: Hey, {{var1}} <br/>Message: Dear Runnr, Your Zomato Background Verification has failed due to {{var2}}. Please find this OTP {{var3}} to do the verification again.<br/>----- CSV File -----<br/> ob_id,var1,var2,var3<br/>OB34308,Manan,Some reason,1234<br/>OB34307,Rahul,Other reason,3214",
  ];

  var now = new Date();
  var currentDateTime = now.toISOString().slice(0, 16);

  var oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(now.getMonth() + 1);
  var oneMonthAfter = oneMonthFromNow.toISOString().slice(0, 16);

  const handleBackClick = () => {
    history.push(`/notification_campaigns`);
  };
  const handleNext = () => {
    let validatedState = validateDetails();
    if (validatedState === "validated") {
      setFormError("");
      setNextView(true);
    } else {
      setFormError(validatedState);
    }
  };

  const validateDetails = () => {
    let err = "";

    Object.keys(inputFieldState).map((key) => {
      if (isValNull(inputFieldState[key])) {
        switch (key) {
          case "campaign_name":
            err = "Campaign Name field is mandatory";
            break;
          case "scheduled_time":
            if (inputFieldState["scheduled_type"] == "LATER") {
              err = "Schedule time selection is mandatory";
            }
            break;
          case "driver_selection_type":
            err = "Driver selection field is mandatory";
            break;
          case "driver_service_id":
            err = "Driver service field is mandatory";
            break;
          case "csv_file_s3_key":
            if (inputFieldState.driver_selection_type == "CSV") {
              err = "Please upload csv file";
            }
            break;
        }
      }
    });
    if (inputFieldState.driver_selection_type == "CSV") {
      if (isValNull(props.uploadedFileName)) {
        err = "Please upload csv file";
      }
    }
    const regexForCampaignName = /^[a-zA-Z0-9_-]+$/;
    if (!regexForCampaignName.test(inputFieldState.campaign_name)) {
      err = "Invalid campaign name";
    }

    return err ? err : "validated";
  };

  const handleChange = (key, val) => {
    if (key == "scheduled_type" && val == "NOW") {
      setInputFieldState((prevState) => {
        return { ...prevState, scheduled_time: "" };
      });
    } else if (key == "scheduled_time" && inputFieldState.expiry_time != "") {
      setInputFieldState((prevState) => {
        return { ...prevState, expiry_time: "" };
      });
    } else if (key == "driver_selection_type") {
      if (val != "GEOGRAPHY") {
        setInputFieldState((prevState) => {
          return {
            ...prevState,
            geography_details: {
              geography_level: "city",
              country_id: "",
              state_ids: [],
              city_ids: [],
              locality_city_ids: [],
              locality_ids: [],
              driver_service_ids: [],
              active_driver_option: "",
            },
          };
        });
      }
      setModalState(val);
    } else if (key == "notification_type" && val == "POPUP") {
      setIsPopup(true);
    } else if (key == "notification_type" && val == "GENERAL") {
      setIsPopup(false);
    } else if (key == "notification_for" && val == "Onboarding Applicants") {
      handleChange("notification_type", "POPUP");
      handleChange("scheduled_type", "NOW");
      props.setUploadedFileName("");
    } else if (key == "notification_for" && val == "Driver Details") {
      handleChange("notification_type", "GENERAL");
      props.setUploadedFileName("");
    }
    setInputFieldState((prevState) => {
      return { ...prevState, [key]: val };
    });
  };

  const handleUploadClose = () => {
    setModalState(false);
  };

  const getInputLabel = (val, options, fromKey, toKey) => {
    if (Object.keys(newCampaignOptions).length > 0) {
      const activeElement = options.find((item) => item[fromKey] === val);
      return activeElement ? activeElement[toKey] : val;
    }
    return val;
  };

  const getModal = () => {
    switch (modalState) {
      case "GEOGRAPHY":
        return (
          <GeographyDetailsModal
            setModalState={setModalState}
            inputFieldState={inputFieldState}
            setInputFieldState={setInputFieldState}
            getInputLabel={getInputLabel}
            newCampaignOptions={newCampaignOptions}
          />
        );
      case "CSV":
        if (inputFieldState.notification_for == "Onboarding Applicants") {
          return (
            <section>
              <BulkUploadFile
                instructions={instructionsCSVUploadOB}
                btnDataTestID="DriverSelectionCSVUploadOB"
                uploadUrl="/notification_campaign/upload_csv/ack"
                sampleURL="/sample/bulk_campaign_notification_ob.csv"
                id="driverSelectionCSVModalOb"
                sendExtraAck={true}
                keyName="callback_key"
                heading="Upload CSV file for OB Applicants"
                useUserUploadedFilename={true}
                getUploadUrl={driverSelectionCSVUpload}
                customHandleClose={handleUploadClose}
                validationType="DriverNotificationOB"
                maxSize={10}
                acceptedFileFormat=".csv"
              />
            </section>
          );
        } else {
          return (
            <section>
              <BulkUploadFile
                instructions={instructionsCSVUpload}
                btnDataTestID="DriverSelectionCSVUpload"
                uploadUrl="/notification_campaign/upload_csv/ack"
                sampleURL="/sample/bulk_campaign_notification.csv"
                id="driverSelectionCSVModal"
                sendExtraAck={true}
                keyName="callback_key"
                heading="Upload CSV file"
                useUserUploadedFilename={true}
                getUploadUrl={driverSelectionCSVUpload}
                customHandleClose={handleUploadClose}
                validationType="DriverNotification"
                maxSize={10}
                acceptedFileFormat=".csv"
              />
            </section>
          );
        }
      default:
        return;
    }
  };

  const getSelectionHelperText = () => {
    switch (inputFieldState.driver_selection_type) {
      case "GEOGRAPHY":
        return (
          <p className="font-10 mb-20 ml-12 text-grey">
            Geography selected
            <br />
            All active Delivery partners
          </p>
        );
      case "CSV":
        return (
          <p className="font-10 mb-20 ml-12 text-grey">
            {props.uploadedFileName}
          </p>
        );
    }
  };

  useEffect(() => {
    Object.keys(newCampaignOptions).length == 0 && getNewCampaignOptions();
  }, []);

  useEffect(() => {
    if (props.activeFilePath) {
      setInputFieldState((prevState) => ({
        ...prevState,
        csv_file_s3_key: props.activeFilePath,
      }));
    } else {
      setInputFieldState((prevState) => ({
        ...prevState,
        driver_selection_type: "",
        csv_file_s3_key: "",
      }));
    }
  }, [props.activeFilePath]);

  return (
    <Permission requiredPerms={[allActions.CAMPAIGN_CREATE]}>
      {nextView ? (
        <NextView
          setNextView={setNextView}
          isPopup={isPopup}
          inputFieldState={inputFieldState}
          setInputFieldState={setInputFieldState}
          newCampaignOptions={newCampaignOptions}
          setDriverServicesPriorityFlag={setDriverServicesPriorityFlag}
        />
      ) : (
        <section>
          <FlexContainer justify="flex-start">
            &emsp;
            <Back
              onClick={handleBackClick}
              className="mr-10 backBtn"
              color={variables.grey400}
            />
            <Breadcrumb className="sushi-breadcrumbs">
              <Breadcrumb.Link onClick={handleBackClick}>
                Notifications
              </Breadcrumb.Link>
              <Breadcrumb.Link>Create campaign</Breadcrumb.Link>
            </Breadcrumb>
          </FlexContainer>
          <FieldsContainer border noPadding className="mt-40">
            <FieldsHolder>
              <FieldsSection marginBottom="1.75rem">
                <p className="section-heading">CAMPAIGN DETAILS</p>
              </FieldsSection>
              <div>
                <FlexContainer className="justify-start">
                  <NamesDiv>
                    <p className="regular ml-5 mb-30">Notification For</p>
                  </NamesDiv>
                  <InputElements>
                    <PaginatedReactDropdown
                      placeholder=""
                      options={notificationForType}
                      labelKey="label"
                      valueKey="value"
                      data-testid="notificationForType"
                      value={getInputLabel(
                        inputFieldState.notification_for,
                        notificationForType,
                        "value",
                        "label"
                      )}
                      handleChange={handleChange}
                      keyToChange="notification_for"
                      id="notificationForType"
                    />
                  </InputElements>
                </FlexContainer>
                {newCampaignOptions.tags && (
                  <FlexContainer className="justify-start">
                    <NamesDiv>
                      <p className="regular ml-5 mb-30">Tag</p>
                    </NamesDiv>
                    <InputElements>
                      <PaginatedReactDropdown
                        placeholder=""
                        options={newCampaignOptions.tags}
                        labelKey="label"
                        valueKey="value"
                        data-testid="newTag"
                        value={getInputLabel(
                          inputFieldState.tag,
                          newCampaignOptions.tags,
                          "value",
                          "label"
                        )}
                        handleChange={handleChange}
                        keyToChange="tag"
                        id="newCampaignTag"
                      />
                    </InputElements>
                  </FlexContainer>
                )}
                <FlexContainer className="justify-start">
                  <NamesDiv>
                    <p className="regular ml-5 mb-30">Campaign Name</p>
                  </NamesDiv>
                  <InputElements>
                    <Input
                      value={inputFieldState.campaign_name}
                      data-testid="newCampaignName"
                      id="sushi-input"
                      onChange={(e) => handleChange("campaign_name", e)}
                      innerWidth="100%"
                      errorMsg={
                        /^[a-zA-Z0-9_-]+$/.test(
                          inputFieldState.campaign_name
                        ) || inputFieldState.campaign_name.length == 0
                          ? ""
                          : "Campaign name should have _ , - or alphanumeric characters."
                      }
                    />
                  </InputElements>
                </FlexContainer>
                {newCampaignOptions.event_triggers &&
                  inputFieldState.notification_for !=
                    "Onboarding Applicants" && (
                    <FlexContainer className="justify-start">
                      <NamesDiv>
                        <p className="regular ml-5 mb-30">Event Trigger</p>
                      </NamesDiv>
                      <InputElements>
                        <PaginatedReactDropdown
                          placeholder=""
                          options={newCampaignOptions.event_triggers}
                          labelKey="label"
                          valueKey="value"
                          data-testid="newTrigger"
                          value={getInputLabel(
                            inputFieldState.event_trigger,
                            newCampaignOptions.event_triggers,
                            "value",
                            "label"
                          )}
                          handleChange={handleChange}
                          keyToChange="event_trigger"
                          id="newCampaignTrigger"
                        />
                      </InputElements>
                    </FlexContainer>
                  )}
                {inputFieldState.notification_for !=
                  "Onboarding Applicants" && (
                  <FlexContainer className="justify-start">
                    <NamesDiv>
                      <p className="regular ml-5 mb-30">Schedule Type</p>
                    </NamesDiv>
                    <InputElements>
                      <PaginatedReactDropdown
                        placeholder=""
                        options={scheduleType}
                        labelKey="label"
                        valueKey="value"
                        data-testid="scheduleType"
                        value={getInputLabel(
                          inputFieldState.scheduled_type,
                          scheduleType,
                          "value",
                          "label"
                        )}
                        handleChange={handleChange}
                        keyToChange="scheduled_type"
                        id="scheduleType"
                      />
                    </InputElements>
                  </FlexContainer>
                )}
                {inputFieldState.scheduled_type == "LATER" && (
                  <FlexContainer className="justify-start">
                    <NamesDiv>
                      <p className="regular ml-5 mb-30">Schedule Time</p>
                    </NamesDiv>
                    <InputElements>
                      <DateTimePicker
                        value={inputFieldState.scheduled_time}
                        handleChange={(e) =>
                          handleChange("scheduled_time", e.target.value)
                        }
                        disableBefore={currentDateTime}
                        disableAfter={oneMonthAfter}
                        placeholder=""
                        id="scheduledTime"
                      />
                    </InputElements>
                  </FlexContainer>
                )}
                <FlexContainer className="justify-start">
                  <NamesDiv>
                    <p className="regular ml-5 mb-30 mt-20">Driver Selection</p>
                  </NamesDiv>
                  <InputElements>
                    <PaginatedReactDropdown
                      placeholder=""
                      options={driverSelectionType}
                      labelKey="label"
                      valueKey="value"
                      data-testid="driverSelectionType"
                      value={getInputLabel(
                        inputFieldState.driver_selection_type,
                        driverSelectionType,
                        "value",
                        "label"
                      )}
                      handleChange={handleChange}
                      keyToChange="driver_selection_type"
                      isOptionDisabled={(option) => {
                        return "Geography" == option;
                      }}
                      showCross={true}
                      id="driverSelectionType"
                      marginBottom="0px"
                    />
                    {getSelectionHelperText()}
                  </InputElements>
                </FlexContainer>
                <FlexContainer className="justify-start">
                  <NamesDiv>
                    <p className="regular ml-5 mb-30 mt-20"></p>
                  </NamesDiv>
                  <InputElements>
                    <InfiniteScrollDropdown
                      priorityFlag={driverServicesPriorityFlag}
                      setPriorityFlag={setDriverServicesPriorityFlag}
                      id="driverServiceIdDropdown"
                      getActiveList={props.getDriverServices}
                      resKey="driver_services"
                      modalState="Edit"
                      keyName="driver_service_id"
                      labelKey="name"
                      getDataLabelKey="name"
                      keyTypeToSet="id"
                      handleChange={handleChange}
                      activeElement={inputFieldState}
                      getActiveItemById={props.getDriverServiceByIds}
                      label="Select Driver Service"
                      multiple
                    />
                  </InputElements>
                </FlexContainer>
                {newCampaignOptions.display_types && (
                  <FlexContainer className="justify-start">
                    <NamesDiv>
                      <p className="regular ml-5 mb-30 mt-20">
                        Notification Type
                      </p>
                    </NamesDiv>
                    <InputElements>
                      <PaginatedReactDropdown
                        placeholder=""
                        options={newCampaignOptions.display_types}
                        labelKey="label"
                        valueKey="value"
                        data-testid="notificationType"
                        value={getInputLabel(
                          inputFieldState.notification_type,
                          newCampaignOptions.display_types,
                          "value",
                          "label"
                        )}
                        handleChange={handleChange}
                        keyToChange="notification_type"
                        id="notificationType"
                        marginTop="25px"
                        isOptionDisabled={(option) => {
                          if (
                            inputFieldState.notification_for ==
                            "Onboarding Applicants"
                          ) {
                            return option == "Tray Notification";
                          }
                        }}
                      />
                    </InputElements>
                  </FlexContainer>
                )}
              </div>
              {formError.length > 0 ? (
                <div className={"error-state"}>{"*" + formError}</div>
              ) : (
                ""
              )}
            </FieldsHolder>
            <FlexContainer justify="flex-end">
              <NextButton>
                <Button
                  data-testid="nextButton"
                  className="sushi-btn w-25"
                  onClick={handleNext}
                >
                  Next &gt;&gt;
                </Button>
              </NextButton>
            </FlexContainer>
          </FieldsContainer>
          {modalState && getModal()}
        </section>
      )}
    </Permission>
  );
};

const NextButton = styled.div`
  flex: 0 1 65%;
  margin-bottom: 30px;
`;
const FieldsHolder = styled.div`
  padding: 1.875rem;
`;

const NamesDiv = styled.div`
  justify-content: flex-start;
  flex: 0 1 50%;
  p {
    font-family: "OkraRegular", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif !important;
    letter-spacing: 1.25px;
  }
`;

const InputElements = styled.div`
  flex: 0 1 50%;
`;

function mapStateToProps(state) {
  const { DriverNotification, User } = state;
  return {
    newCampaignOptions: DriverNotification.newCampaignOptions,
    uploadedFileName: User.uploadedFileName,
    activeFilePath: User.activeFilePath,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNewCampaignOptions: bindActionCreators(
      DriverNotificationActions.getNewCampaignOptions,
      dispatch
    ),
    driverSelectionCSVUpload: bindActionCreators(
      DriverNotificationActions.driverSelectionCSVUpload,
      dispatch
    ),
    getDriverServices: bindActionCreators(
      DriverServiceActions.getDriverServices,
      dispatch
    ),
    getDriverServiceByIds: bindActionCreators(
      DriverServiceActions.getDriverServiceByIds,
      dispatch
    ),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    resetState: bindActionCreators(
      DriverNotificationActions.resetState,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewCampaign);
